/* Tech Store — storefront interactions: hero carousel, ajax add-to-cart, variant selector */
(function () {
  var routes = (window.TechStore && window.TechStore.routes) || {};
  var strings = (window.TechStore && window.TechStore.strings) || {};
  strings.decrease = strings.decrease || 'Decrease quantity';
  strings.increase = strings.increase || 'Increase quantity';
  strings.remove   = strings.remove   || 'Remove';
  strings.stock_capped = strings.stock_capped || 'Only [qty] left in stock — quantity updated.';
  strings.cart_error   = strings.cart_error   || 'Could not update the cart. Please try again.';
  strings.add_error    = strings.add_error    || 'Could not add to cart.';
  strings.added        = strings.added        || 'Added \u2713';
  strings.try_again    = strings.try_again    || 'Try again';
  strings.add_to_cart  = strings.add_to_cart  || 'Add to cart';
  strings.sold_out     = strings.sold_out     || 'Sold out';
  strings.unavailable  = strings.unavailable  || 'Unavailable';
  strings.in_stock     = strings.in_stock     || 'In stock';
  strings.copied       = strings.copied       || 'Link copied';
  /* Neutral fallback on purpose: inventing '$' on a rupee store is worse than
     showing a bare number if the layout ever fails to publish money_format. */
  var moneyFormat = (window.TechStore && window.TechStore.money_format) || '{{amount}}';

  /* Shopify prefixes every storefront path on a localised market (/en-in/...).
     Hardcoding '/cart/add.js' 404s there, so build every cart URL from the
     routes Shopify gave us and fall back to the unprefixed path only if absent. */
  var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function cartUrl(suffix) {
    var base = routes.cart_url || (rootPath.replace(/\/$/, '') + '/cart');
    return base + (suffix || '');
  }
  function cartAddUrl()    { return (routes.cart_add_url    || cartUrl('/add'))    + '.js'; }
  function cartChangeUrl() { return (routes.cart_change_url || cartUrl('/change')) + '.js'; }
  function checkoutUrl() { return cartUrl('').replace(/\/cart$/, '/checkout'); }
  function isCartPath(href) {
    var root = rootPath.replace(/\/$/, '');
    return href.indexOf(root + '/cart') === 0 ||
           href.indexOf(root + '/checkout') === 0 ||
           href.indexOf(root + '/account') === 0 ||
           href.indexOf('/cart') === 0 || href.indexOf('/checkout') === 0 || href.indexOf('/account') === 0;
  }

  /* ---------- money ---------- */
  function formatMoney(cents) {
    cents = cents || 0;
    function fmt(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      var value = (number / 100.0).toFixed(precision);
      var parts = value.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cent = parts[1] ? decimal + parts[1] : '';
      return dollars + cent;
    }
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, name) {
      switch (name) {
        case 'amount': return fmt(cents, 2);
        case 'amount_no_decimals': return fmt(cents, 0);
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return fmt(cents, 0, ' ');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'");
        case 'amount_no_decimals_with_apostrophe_separator': return fmt(cents, 0, "'");
        default: return fmt(cents, 2);
      }
    });
  }

  window.TechStore = window.TechStore || {};
  window.TechStore.formatMoney = formatMoney;

  /* ---------- cart count ---------- */
  function refreshCartCount() {
    fetch(cartUrl('.js'), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-ts-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      })
      .catch(function () {});
  }

  function announce(msg) {
    var live = document.querySelector('[data-ts-live]');
    if (!live || !msg) return;
    live.textContent = '';
    window.setTimeout(function () { live.textContent = msg; }, 60);
  }

  function flashButton(btn, text) {
    if (!btn) return;
    var label = btn.querySelector('[data-ts-add-label]') || btn;
    /* Capture the true original ONCE. Without this, a second flash records the
       temporary text as the original and the button keeps it forever. */
    if (!label.dataset.tsOriginal) label.dataset.tsOriginal = label.textContent.trim();
    if (btn._tsFlash) clearTimeout(btn._tsFlash);
    label.textContent = text;
    btn._tsFlash = setTimeout(function () {
      label.textContent = label.dataset.tsOriginal;
      btn._tsFlash = null;
    }, 1400);
  }

  /* ---------- ajax add to cart ---------- */
  function showCartError(form, msg) {
    var el = form && form.querySelector('[data-ts-cart-error]');
    if (!el) return;
    if (!msg) { el.style.display = 'none'; el.textContent = ''; return; }
    el.textContent = msg;
    el.style.display = 'block';
  }

  function ajaxAdd(form, btn) {
    /* btn = the button the shopper actually pressed. Falling back to the first
       submit in the form is what made the buy-box button show another button's
       result. */
    btn = btn || form.querySelector('button[type="submit"]');
    var data = new FormData(form);
    if (btn) { btn.disabled = true; btn.style.opacity = '.65'; }
    fetch(cartAddUrl(), {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: data
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (btn) { btn.disabled = false; btn.style.opacity = ''; }
        if (!res.ok) {
          var msg = (res.body && (res.body.description || res.body.message)) || strings.add_error;
          showCartError(form, msg);
          announce(msg);
          flashButton(btn, strings.unavailable);
          return;
        }
        showCartError(form, '');
        flashButton(btn, strings.added);
        announce(strings.added);
        /* openCart() calls loadCart(), which already refreshes the header count —
           a second /cart.js request here would be pure duplication. */
        openCart();
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.style.opacity = ''; }
        flashButton(btn, strings.try_again);
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-ts-add], [data-ts-product-form]');
    if (!form) return;
    e.preventDefault();
    ajaxAdd(form, e.submitter || form.querySelector('[data-ts-add-btn]'));
  });

  /* Restored after e0e45c1 deleted them while boot() still called them. */
  function initFilters() {
    /* Open at every width. Below 980px the summary is hidden and the panel is the
       drawer's whole body, so a closed <details> there just renders nothing. */
    document.querySelectorAll('[data-ts-filters]').forEach(function (d) {
      d.setAttribute('open', '');
    });
  }

  var waBooted = false;
  function initWaWidget() {
    if (waBooted) return;
    waBooted = true;
    var body = document.body;
    var scoped = body.classList.contains('template-product') ||
                 body.classList.contains('template-collection') ||
                 body.classList.contains('template-cart');
    if (!scoped) return;

    function findWidgetParts() {
      var parts = [];
      var all = document.body.querySelectorAll('div,section,aside,iframe,a,button');
      for (var i = 0; i < all.length; i++) {
        var el = all[i];
        var cs;
        try { cs = window.getComputedStyle(el); } catch (e) { continue; }
        if (cs.position !== 'fixed') continue;
        if (el.closest('.ts-pd-stickybar')) continue;
        var probe = ((el.id || '') + ' ' + (typeof el.className === 'string' ? el.className : '') + ' ' +
                     (el.getAttribute('src') || '') + ' ' + (el.getAttribute('href') || '')).toLowerCase();
        var inner = '';
        try { inner = (el.innerHTML || '').slice(0, 5000).toLowerCase(); } catch (e) {}
        if (/whatsapp|aisensy|wa\.me|wa-widget|wa-chat/.test(probe) || /whatsapp|aisensy|wa\.me/.test(inner)) {
          /* keep only outermost fixed containers */
          var contained = false;
          for (var p = 0; p < parts.length; p++) { if (parts[p].contains(el)) { contained = true; break; } }
          if (!contained) parts.push(el);
        }
      }
      return parts;
    }

    var controlled = [];
    function setVisible(on) {
      controlled.forEach(function (el) {
        el.style.setProperty('opacity', on ? '1' : '0', 'important');
        el.style.setProperty('visibility', on ? 'visible' : 'hidden', 'important');
        el.style.setProperty('pointer-events', on ? 'auto' : 'none', 'important');
        el.style.setProperty('transition', 'opacity .3s ease', 'important');
      });
    }

    var lastY = window.scrollY;
    function judge() {
      if (!controlled.length) return;
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var pct = max > 0 ? window.scrollY / max : 1;
      var goingDown = window.scrollY >= lastY;
      lastY = window.scrollY;
      setVisible(pct >= 0.6 && goingDown);
    }
    window.addEventListener('scroll', judge, { passive: true });
    waScrollGate = judge;

    var tries = 0;
    var poll = setInterval(function () {
      var found = findWidgetParts();
      if (found.length) {
        found.forEach(function (el) {
          if (controlled.indexOf(el) === -1) {
            controlled.push(el);
            /* lift the bubble above the sticky CTA bar on mobile product pages */
            if (body.classList.contains('template-product') && window.innerWidth <= 820) {
              var b = parseInt(window.getComputedStyle(el).bottom, 10);
              if (!isNaN(b) && b < 60) el.style.setProperty('bottom', '86px', 'important');
            }
          }
        });
        setVisible(false);
        judge();
      }
      /* keep polling the whole window: AiSensy injects pieces late and on open */
      if (tries++ > 40) clearInterval(poll);
    }, 500);
  }

  /* The cart/filter drawers hide the chat bubble while open; on close, hand
     control back to the scroll gate instead of forcing it visible. */
  var waScrollGate = null;

  /* ---------- predictive search: import on interaction ----------
     The panel's markup is already in the header; its behaviour is a separate
     asset fetched the first time a shopper actually opens search. */
  var searchLoading = false;
  function loadSearchModule(then) {
    if (window.TechStore && window.TechStore.openSearch) { then(); return; }
    if (searchLoading) return;
    searchLoading = true;
    var el = document.querySelector('[data-ts-search-panel]');
    var src = el && el.getAttribute('data-module');
    if (!src) return;
    var tag = document.createElement('script');
    tag.src = src;
    tag.onload = function () { then(); };
    document.head.appendChild(tag);
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-ts-search-open]');
    if (!open) return;
    e.preventDefault();
    loadSearchModule(function () {
      if (window.TechStore && window.TechStore.openSearch) window.TechStore.openSearch(open);
    });
  });

  /* ---------- header dropdowns / mega menu ----------
     Click driven by default. The panel sits 14px below the button, and a
     document-level mouseover close meant that crossing that gap on the way down
     to the menu counted as leaving the item — the panel closed under the cursor
     and the link underneath never got the click. Hover is now opt-in per store
     and, when it is on, the gap is bridged so the pointer never leaves. */
  function closeNav(except) {
    document.querySelectorAll('[data-ts-nav-item][data-open]').forEach(function (item) {
      if (item === except) return;
      item.removeAttribute('data-open');
      var btn = item.querySelector('[data-ts-nav-toggle]');
      var panel = item.querySelector('[data-ts-nav-panel]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
    });
  }

  function openNav(item) {
    closeNav(item);
    item.setAttribute('data-open', '');
    var btn = item.querySelector('[data-ts-nav-toggle]');
    var panel = item.querySelector('[data-ts-nav-panel]');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    if (panel) panel.hidden = false;
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-ts-nav-toggle]');
    if (toggle) {
      e.preventDefault();
      var item = toggle.closest('[data-ts-nav-item]');
      if (item.hasAttribute('data-open')) closeNav(null);
      else openNav(item);
      return;
    }
    /* A link inside the panel: let the browser navigate, just close behind it. */
    if (e.target.closest('[data-ts-nav-panel]')) { closeNav(null); return; }
    closeNav(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var open = document.querySelector('[data-ts-nav-item][data-open]');
      if (open) {
        var btn = open.querySelector('[data-ts-nav-toggle]');
        closeNav(null);
        if (btn) btn.focus();
      }
    }
  });

  document.addEventListener('focusout', function (e) {
    var item = e.target.closest && e.target.closest('[data-ts-nav-item]');
    if (!item) return;
    window.setTimeout(function () {
      if (!item.contains(document.activeElement)) closeNav(null);
    }, 0);
  });

  /* Hover, only when the merchant asked for it and the device actually has a
     pointer. Bound per item with enter/leave, so moving inside the item — button,
     gap bridge or panel — never registers as leaving it. */
  function initNavHover() {
    var nav = document.querySelector('[data-ts-nav][data-nav-trigger="hover"]');
    if (!nav) return;
    if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    nav.querySelectorAll('[data-ts-nav-item]').forEach(function (item) {
      if (item.dataset.hoverBound) return;
      item.dataset.hoverBound = '1';
      var leaveTimer;
      item.addEventListener('mouseenter', function () {
        window.clearTimeout(leaveTimer);
        openNav(item);
      });
      item.addEventListener('mouseleave', function () {
        /* A short grace period so a diagonal move across a neighbouring item
           does not snap the panel shut mid-travel. */
        leaveTimer = window.setTimeout(function () {
          if (!item.matches(':hover')) closeNav(null);
        }, 180);
      });
    });
  }

  /* ---------- page scroll lock ----------
     Setting overflow on <body> alone does not stop the page moving when <html>
     is the scroller, which left the storefront scrolling behind an open drawer.
     Locking <html> removes its scrollbar, so the padding compensation below keeps
     the page from jumping sideways as the drawer opens. */
  var scrollLocks = 0;
  function lockScroll(on) {
    var root = document.documentElement;
    if (on) {
      scrollLocks++;
      if (scrollLocks > 1) return;
      var bar = window.innerWidth - root.clientWidth;
      root.dataset.tsScrollPad = root.style.paddingRight || '';
      if (bar > 0) root.style.paddingRight = bar + 'px';
      root.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    } else {
      if (scrollLocks === 0) return;
      scrollLocks--;
      if (scrollLocks > 0) return;
      root.style.overflow = '';
      root.style.paddingRight = root.dataset.tsScrollPad || '';
      document.body.style.overflow = '';
    }
  }

  /* ---------- shared modal focus management ----------
     One open dialog at a time. Tab is kept inside the panel and focus returns to
     whatever opened it, which is what WCAG 2.4.3 / 2.1.2 ask of a modal. */
  var openDialog = null;
  var dialogReturn = null;

  function focusables(scope) {
    return Array.prototype.filter.call(
      scope.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetWidth || el.offsetHeight || el.getClientRects().length; }
    );
  }

  function trapDialog(panel, returnTo) {
    openDialog = panel;
    dialogReturn = returnTo || document.activeElement;
    /* Focus the dialog itself, not its first control. Focusing the close button
       made Chrome paint a :focus-visible ring on it the moment the drawer opened,
       even on a tap — it read as a highlighted, half-pressed button. Moving focus
       to the container is also what WCAG asks for: a screen reader then announces
       the dialog's label before its contents. */
    if (!panel || !panel.focus) return;
    panel.setAttribute('tabindex', '-1');
    panel.focus({ preventScroll: true });
  }

  function releaseDialog() {
    openDialog = null;
    if (dialogReturn && dialogReturn.focus) dialogReturn.focus();
    dialogReturn = null;
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !openDialog) return;
    var items = focusables(openDialog);
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    else if (!openDialog.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
  });

  /* ---------- hamburger menu drawer ---------- */
  /* Recovered: this was dropped when theme.js was rewritten at e0e45c1, which
     left the burger button inert on every page. */
  document.addEventListener('click', function (e) {
    var burger = e.target.closest('[data-ts-burger]');
    var closer = e.target.closest('[data-ts-drawer-close]');
    var drawer = document.querySelector('[data-ts-drawer]');
    if (!drawer) return;
    if (burger) {
      e.preventDefault();
      drawer.hidden = false;
      lockScroll(true);
      burger.setAttribute('aria-expanded', 'true');
      waHide(true);
      trapDialog(drawer.querySelector('.ts-drawer-panel') || drawer, burger);
    } else if (closer) {
      e.preventDefault();
      drawer.hidden = true;
      lockScroll(false);
      waHide(false);
      var b = document.querySelector('[data-ts-burger]');
      if (b) b.setAttribute('aria-expanded', 'false');
      releaseDialog();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var drawer = document.querySelector('[data-ts-drawer]');
    if (drawer && !drawer.hidden) {
      drawer.hidden = true;
      lockScroll(false);
      waHide(false);
      var b = document.querySelector('[data-ts-burger]');
      if (b) b.setAttribute('aria-expanded', 'false');
    }
  });

  /* ---------- collection filter drawer ---------- */
  function filterOpen(open) {
    var col = document.querySelector('[data-ts-filter-col]');
    var bd  = document.querySelector('.ts-filter-backdrop');
    if (!col) return;
    col.classList.toggle('is-open', open);
    if (bd) bd.hidden = !open;
    lockScroll(open);
    var trigger = document.querySelector('[data-ts-filter-open]');
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    waHide(open);
    /* Only a modal on narrow screens; on desktop the column is a visible sidebar,
       so it must not claim dialog semantics there. */
    if (window.innerWidth > 980) {
      col.removeAttribute('role');
      col.removeAttribute('aria-modal');
      return;
    }
    if (open) {
      col.setAttribute('role', 'dialog');
      col.setAttribute('aria-modal', 'true');
      trapDialog(col, trigger);
    } else {
      col.removeAttribute('role');
      col.removeAttribute('aria-modal');
      if (openDialog === col) releaseDialog();
    }
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-ts-filter-open]'))  { e.preventDefault(); filterOpen(true);  return; }
    if (e.target.closest('[data-ts-filter-close]')) { e.preventDefault(); filterOpen(false); return; }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') filterOpen(false); });

  /* ---------- side cart drawer ---------- */
  /* Chat widgets inject at a very high z-index and swallow taps on our own UI. */
  var waNodes = null;
  function waFind() {
    if (waNodes) return waNodes;
    waNodes = [];
    /* Walk everything under <body>. AiSensy injects late and can nest deeper
       than two levels, which is how its button stayed clickable over the cart
       and swallowed a Checkout tap. */
    var all = document.body ? document.body.querySelectorAll('*') : [];
    Array.prototype.forEach.call(all, function (el) {
      if (!el || el.nodeType !== 1) return;
      if (el.closest('[data-ts-cart-drawer], [data-ts-filter-col], [data-ts-drawer], .ts-filter-backdrop, header')) return;
      var cs;
      try { cs = window.getComputedStyle(el); } catch (e) { return; }
      if (cs.position !== 'fixed') return;
      var z = parseInt(cs.zIndex, 10);
      var cls = el.className && el.className.baseVal !== undefined ? el.className.baseVal : (el.className || '');
      var hay = ((el.id || '') + ' ' + cls).toLowerCase();
      var isChat = /whats|aisensy|wa[-_]?widget|chat|gallabox|tawk|crisp|intercom/.test(hay);
      var hasWa  = el.querySelector && el.querySelector('a[href*="wa.me"], a[href*="whatsapp"]');
      /* A high z-index alone is not enough: a cookie banner or a review popup
         would match too. Require it to also sit in a screen corner and be small,
         which is what a floating chat launcher is. */
      var isFloating = false;
      if (!isNaN(z) && z >= 1000) {
        var r = el.getBoundingClientRect();
        var nearBottom = r.bottom > window.innerHeight - 200;
        var nearEdge = r.left > window.innerWidth - 260 || r.right < 260;
        isFloating = nearBottom && nearEdge && r.width < 400 && r.height < 400;
      }
      if (isChat || hasWa || isFloating) waNodes.push(el);
    });
    return waNodes;
  }

  function waHide(hide) {
    if (hide) waNodes = null;          /* rescan: the widget loads late */
    var restore = false;
    waFind().forEach(function (el) {
      if (hide) {
        if (el.dataset.tsWaPrev === undefined) {
          el.dataset.tsWaPrev = el.style.visibility || '';
          el.dataset.tsWaPrevPe = el.style.pointerEvents || '';
        }
        el.style.visibility = 'hidden';
        el.style.pointerEvents = 'none';
      } else {
        el.style.visibility = el.dataset.tsWaPrev || '';
        el.style.pointerEvents = el.dataset.tsWaPrevPe || '';
        delete el.dataset.tsWaPrev;
        delete el.dataset.tsWaPrevPe;
        restore = true;
      }
    });
    if (restore && waScrollGate) waScrollGate();
  }

  var cartDrawer, cartLines, cartFoot, cartEmpty, cartSub, cartHeadCount, lastFocus;

  function cartEls() {
    if (cartDrawer !== undefined) return cartDrawer;
    cartDrawer = document.querySelector('[data-ts-cart-drawer]') || null;
    if (cartDrawer) {
      cartLines     = cartDrawer.querySelector('[data-ts-cart-lines]');
      cartFoot      = cartDrawer.querySelector('[data-ts-cart-foot]');
      cartEmpty     = cartDrawer.querySelector('[data-ts-cart-empty]');
      cartSub       = cartDrawer.querySelector('[data-ts-cart-subtotal]');
      cartHeadCount = cartDrawer.querySelector('[data-ts-cart-drawer-count]');
    }
    return cartDrawer;
  }

  function thumb(url, w) {
    if (!url) return '';
    try {
      var u = new URL(url, window.location.origin);
      u.searchParams.set('width', w);
      return u.toString();
    } catch (e) { return url; }
  }

  function renderCart(cart) {
    if (!cartEls()) return;
    if (cartHeadCount) cartHeadCount.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';

    if (!cart.items || !cart.items.length) {
      cartLines.textContent = '';
      cartLines.hidden = true;
      if (cartEmpty) cartEmpty.hidden = false;
      if (cartFoot) cartFoot.hidden = true;
      return;
    }
    cartLines.hidden = false;
    if (cartEmpty) cartEmpty.hidden = true;
    if (cartFoot) cartFoot.hidden = false;

    /* createElement + textContent only: titles and properties are untrusted. */
    var frag = document.createDocumentFragment();

    cart.items.forEach(function (it) {
      var row = document.createElement('div');
      row.className = 'ts-cart-line';
      row.setAttribute('data-key', it.key);

      var img = thumb(it.image, 160);
      if (img) {
        var thumbLink = document.createElement('a');
        thumbLink.className = 'ts-cart-thumb';
        thumbLink.href = it.url;
        var im = document.createElement('img');
        im.src = img; im.alt = ''; im.width = 72; im.height = 72;
        im.loading = 'lazy'; im.decoding = 'async';
        thumbLink.appendChild(im);
        row.appendChild(thumbLink);
      } else {
        var blank = document.createElement('span');
        blank.className = 'ts-cart-thumb is-blank';
        row.appendChild(blank);
      }

      var info = document.createElement('div');
      info.className = 'ts-cart-info';

      var title = document.createElement('a');
      title.className = 'ts-cart-title';
      title.href = it.url;
      title.textContent = it.product_title;
      info.appendChild(title);

      if (it.variant_title && !it.product_has_only_default_variant) {
        var vt = document.createElement('div');
        vt.className = 'ts-cart-variant';
        vt.textContent = it.variant_title;
        info.appendChild(vt);
      }

      /* line item properties, if an app or a form added any */
      if (it.properties) {
        Object.keys(it.properties).forEach(function (k) {
          if (!k || k.charAt(0) === '_' || !it.properties[k]) return;
          var pr = document.createElement('div');
          pr.className = 'ts-cart-variant';
          pr.textContent = k + ': ' + it.properties[k];
          info.appendChild(pr);
        });
      }

      var priceLine = document.createElement('div');
      priceLine.className = 'ts-cart-priceline';
      priceLine.appendChild(document.createTextNode(formatMoney(it.final_line_price)));
      if (it.original_line_price > it.final_line_price) {
        var was = document.createElement('s');
        was.className = 'ts-cart-was';
        was.textContent = formatMoney(it.original_line_price);
        priceLine.appendChild(document.createTextNode(' '));
        priceLine.appendChild(was);
      }
      info.appendChild(priceLine);

      var qty = document.createElement('div');
      qty.className = 'ts-cart-qty';

      /* Line keys, not indexes: an index captured at render time points at the
         wrong item if the cart changed server-side in the meantime. */
      function qtyButton(to, label, aria) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('data-ts-qty', it.key);
        b.setAttribute('data-to', String(to));
        b.setAttribute('aria-label', aria);
        b.textContent = label;
        return b;
      }
      qty.appendChild(qtyButton(it.quantity - 1, '\u2212', strings.decrease));
      var count = document.createElement('span');
      count.textContent = it.quantity;
      qty.appendChild(count);
      qty.appendChild(qtyButton(it.quantity + 1, '+', strings.increase));

      var remove = qtyButton(0, strings.remove, strings.remove);
      remove.className = 'ts-cart-remove';
      qty.appendChild(remove);

      info.appendChild(qty);
      row.appendChild(info);
      frag.appendChild(row);
    });

    cartLines.textContent = '';
    cartLines.appendChild(frag);

    if (cartSub) cartSub.textContent = formatMoney(cart.total_price);

    var ship = document.querySelector('[data-ts-cart-ship]');
    if (ship) {
      var threshold = parseInt(ship.getAttribute('data-threshold'), 10) || 0;
      if (threshold > 0 && cart.item_count > 0) {
        ship.hidden = false;
        var remaining = threshold - cart.total_price;
        var text = ship.querySelector('[data-ts-cart-ship-text]');
        var fill = ship.querySelector('[data-ts-cart-ship-fill]');
        if (remaining > 0) {
          if (text) text.textContent = (ship.getAttribute('data-progress-text') || '')
            .replace('[amount]', formatMoney(remaining));
          if (fill) fill.style.width = Math.round((cart.total_price / threshold) * 100) + '%';
        } else {
          if (text) text.textContent = ship.getAttribute('data-reached-text') || '';
          if (fill) fill.style.width = '100%';
        }
      } else {
        ship.hidden = true;
      }
    }

    var cross = document.querySelector('[data-ts-cart-cross]');
    if (cross) {
      var inCart = {};
      (cart.items || []).forEach(function (it) { inCart[String(it.product_id)] = true; });
      var visible = 0;
      cross.querySelectorAll('[data-product-id]').forEach(function (row) {
        var already = inCart[row.getAttribute('data-product-id')];
        row.hidden = !!already;
        if (!already) visible++;
      });
      cross.hidden = cart.item_count === 0 || visible === 0;
    }
  }

  function loadCart() {
    return fetch(cartUrl('.js'), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCart(cart);
        document.querySelectorAll('[data-ts-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
        return cart;
      })
      .catch(function () {});
  }

  function openCart() {
    if (!cartEls()) { window.location.href = cartUrl(''); return; }
    lastFocus = document.activeElement;
    cartDrawer.hidden = false;
    lockScroll(true);
    loadCart();
    waHide(true);
    trapDialog(cartDrawer.querySelector('.ts-cart-panel') || cartDrawer, lastFocus);
  }

  function closeCart() {
    if (!cartEls() || cartDrawer.hidden) return;
    cartDrawer.hidden = true;
    lockScroll(false);
    waHide(false);
    releaseDialog();
  }

  /* Keyed, not indexed: /cart/change.js accepts the line item key, which stays
     correct even if the cart changed server-side since this render. */
  function setLine(key, qty) {
    var want = Number(qty);
    return fetch(cartChangeUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: String(key), quantity: want })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, cart: j }; }); })
      .then(function (res) {
        if (!res.ok) { showDrawerNotice(res.cart && res.cart.description); return; }
        var cart = res.cart;
        renderCart(cart);
        document.querySelectorAll('[data-ts-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
        /* Shopify silently caps the quantity at available stock. Say so rather
           than letting the number quietly change under the shopper. */
        var line = (cart.items || []).filter(function (i) { return i.key === String(key); })[0];
        if (want > 0 && line && line.quantity < want) {
          showDrawerNotice(strings.stock_capped.replace('[qty]', line.quantity));
        } else {
          showDrawerNotice('');
        }
      })
      .catch(function () { showDrawerNotice(strings.cart_error); });
  }

  function showDrawerNotice(msg) {
    announce(msg);
    if (!cartEls()) return;
    var el = cartDrawer.querySelector('[data-ts-cart-notice]');
    if (!el) return;
    if (!msg) { el.hidden = true; el.textContent = ''; return; }
    el.textContent = msg;
    el.hidden = false;
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-ts-cart-open]');
    if (open && cartEls()) { e.preventDefault(); openCart(); return; }

    if (e.target.closest('[data-ts-cart-close]')) { e.preventDefault(); closeCart(); return; }

    var q = e.target.closest('[data-ts-qty]');
    if (q) {
      e.preventDefault();
      setLine(q.getAttribute('data-ts-qty'), q.getAttribute('data-to'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (window.TechStore && window.TechStore.closeSearch) window.TechStore.closeSearch();
    closeCart();
    filterOpen(false);
    var drawer = document.querySelector('[data-ts-drawer]');
    if (drawer && !drawer.hidden) {
      drawer.hidden = true;
      lockScroll(false);
      waHide(false);
      var b = document.querySelector('[data-ts-burger]');
      if (b) b.setAttribute('aria-expanded', 'false');
      releaseDialog();
    }
  });

  /* ---------- cart page line quantity / remove ----------
     Keyed against item.key, never a render-time line index: an index goes stale
     the moment another line is removed and then edits the wrong product. */
  function cartPageUpdate(key, qty, fallbackHref) {
    return fetch(cartChangeUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: String(key), quantity: qty })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart');
        return r.json();
      })
      .then(function () { window.location.reload(); })
      .catch(function () {
        if (fallbackHref) window.location.href = fallbackHref;
      });
  }

  function lineKeyOf(el) {
    var row = el.closest('[data-ts-cart-line]');
    return row ? row.getAttribute('data-line-key') : null;
  }

  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-ts-line-remove]');
    if (remove) {
      var rKey = lineKeyOf(remove);
      if (!rKey) return;
      e.preventDefault();
      cartPageUpdate(rKey, 0, remove.href);
      return;
    }

    var step = e.target.closest('[data-ts-line-step]');
    if (!step) return;
    var row = step.closest('[data-ts-cart-line]');
    var input = row && row.querySelector('[data-ts-line-qty]');
    if (!input) return;
    var delta = parseInt(step.getAttribute('data-ts-line-step'), 10) || 0;
    var next = (parseInt(input.value, 10) || 0) + delta;
    var max = parseInt(input.getAttribute('max'), 10);
    if (next < 0) next = 0;
    if (!isNaN(max) && next > max) next = max;
    input.value = next;
    cartPageUpdate(row.getAttribute('data-line-key'), next, null);
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-ts-line-qty]');
    if (!input) return;
    var row = input.closest('[data-ts-cart-line]');
    if (!row) return;
    var n = parseInt(input.value, 10);
    if (isNaN(n) || n < 0) n = 0;
    var max = parseInt(input.getAttribute('max'), 10);
    if (!isNaN(max) && n > max) n = max;
    input.value = n;
    cartPageUpdate(row.getAttribute('data-line-key'), n, null);
  });

  

  

  /* ---------- marquee ---------- */
  


  /* ---------- buy now + sticky bar (product page) ---------- */
  document.addEventListener('click', function (e) {
    var sticky = e.target.closest('[data-ts-sticky-add]');
    var buynow = e.target.closest('[data-ts-buynow]');
    if (!sticky && !buynow) return;
    var form = document.querySelector('[data-ts-product-form]');
    if (!form) return;
    e.preventDefault();
    if (sticky) { ajaxAdd(form, sticky); return; }
    /* Buy now: add the selected variant, then straight to checkout */
    var data = new FormData(form);
    if (buynow) { buynow.disabled = true; buynow.style.opacity = '.65'; }
    fetch(cartAddUrl(), {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: data
    }).then(function (r) {
      if (!r.ok) { if (buynow) { buynow.disabled = false; buynow.style.opacity = ''; } flashButton(buynow, 'Unavailable'); return; }
      window.location.href = checkoutUrl();
    }).catch(function () { window.location.href = checkoutUrl(); });
  });


  /* ---------- filter groups: value search + show more ---------- */
  function initFilterGroups() {
    document.querySelectorAll('[data-ts-filter-more]').forEach(function (btn) {
      if (btn.dataset.init) return;
      btn.dataset.init = '1';
      btn.addEventListener('click', function () {
        var list = btn.parentElement.querySelector('[data-ts-filter-list]');
        if (!list) return;
        var open = list.classList.toggle('is-open');
        btn.textContent = open ? btn.dataset.less : btn.dataset.more;
      });
    });
    document.querySelectorAll('[data-ts-filter-search]').forEach(function (input) {
      if (input.dataset.init) return;
      input.dataset.init = '1';
      input.addEventListener('input', function () {
        var q = input.value.trim().toLowerCase();
        var wrap = input.closest('div').parentElement;
        var list = wrap.querySelector('[data-ts-filter-list]');
        var more = wrap.querySelector('[data-ts-filter-more]');
        if (!list) return;
        if (q) { list.classList.add('is-open'); if (more) more.style.display = 'none'; }
        else { list.classList.remove('is-open'); if (more) { more.style.display = ''; more.textContent = more.dataset.more; } }
        list.querySelectorAll('[data-ts-filter-value]').forEach(function (opt) {
          opt.classList.toggle('is-hidden', q !== '' && opt.getAttribute('data-ts-filter-value').indexOf(q) === -1);
        });
      });
    });
  }


  /* ---------- instant navigation: prefetch links on intent ---------- */
  var prefetchBooted = false;
  function initPrefetch() {
    if (prefetchBooted) return;
    prefetchBooted = true;
    if (navigator.connection && (navigator.connection.saveData || /2g/.test(navigator.connection.effectiveType || ''))) return;
    var done = {};
    function prefetch(url) {
      if (!url || done[url]) return;
      done[url] = 1;
      var l = document.createElement('link');
      l.rel = 'prefetch';
      l.href = url;
      l.as = 'document';
      document.head.appendChild(l);
    }
    function candidate(e) {
      var a = e.target.closest('a[href]');
      if (!a) return null;
      var href = a.getAttribute('href') || '';
      if (!href.startsWith('/') || href.startsWith('//')) return null;
      if (isCartPath(href)) return null;
      if (a.hasAttribute('download') || a.target === '_blank') return null;
      return a.href;
    }
    var t;
    document.addEventListener('mouseover', function (e) {
      var url = candidate(e);
      if (!url) return;
      clearTimeout(t);
      t = setTimeout(function () { prefetch(url); }, 65);
    }, { passive: true });
    document.addEventListener('mouseout', function () { clearTimeout(t); }, { passive: true });
    document.addEventListener('touchstart', function (e) {
      var url = candidate(e);
      if (url) prefetch(url);
    }, { passive: true });
  }

  /* ---------- boot ---------- */
  /* ---------- customer address: province select + delete ----------
     Shopify's country_option_tags puts a data-provinces JSON array on each
     <option>. Without this the province select renders empty and a customer
     cannot save a state, so the address form fails validation at checkout. */



  /* Replaces the inline onload= that used to sit on every image: an inline
     handler forces script-src 'unsafe-inline' in any CSP the store adds later. */
  function fadeImages(scope) {
    scope.querySelectorAll('img[data-ts-fade]').forEach(function (img) {
      if (img.complete && img.naturalWidth) { img.classList.add('is-in'); return; }
      img.addEventListener('load', function () { img.classList.add('is-in'); }, { once: true });
      img.addEventListener('error', function () { img.classList.add('is-in'); }, { once: true });
    });
  }

  window.TechStore = window.TechStore || {};
  window.TechStore.waHide = waHide;
  window.TechStore.lockScroll = lockScroll;
  window.TechStore.trapDialog = trapDialog;
  window.TechStore.releaseDialog = releaseDialog;
  window.TechStore.filterOpen = filterOpen;
  window.TechStore.initFilters = initFilters;
  window.TechStore.initFilterGroups = initFilterGroups;
  window.TechStore.fadeImages = fadeImages;

  function boot() {
    fadeImages(document);
    initNavHover();
    initFilters();
    initFilterGroups();
    initPrefetch();
    initWaWidget();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function () { boot(); });

  document.addEventListener('shopify:section:unload', function (e) {
    var scope = e.target;
    if (!scope || !scope.querySelectorAll) return;
    scope.querySelectorAll('[data-ts-hero]').forEach(function (hero) {
      if (typeof hero._tsStop === 'function') hero._tsStop();
    });
  });
})();
